document.addEventListener('rebuy:smartcart.ready', () => {
  handleRebuyHooks()
});
document.addEventListener('rebuy:cart.change', () => {
  handleRebuyHooks()
});

let rebuySmartCartItems = []
let rebuyWaitForProductDataCounter = 0

function handleRebuyHooks() {
  const rebuyPack = document.querySelector("#rebuy-cart .rebuy-cart__pack")

  if(rebuyPack) {
    handleChangesInSmartCart(rebuyPack);

    if (!rebuyPack.classList.contains('event-added')) {
      rebuyPack.classList.add('event-added')
      const inputs = rebuyPack.querySelectorAll('input')

      inputs.forEach((input) => {
        input.addEventListener('click', () => handleSmartCartPackingSelection(rebuyPack))
      })
    }
  } else {
    smartCartUpdatePackingCartAttribute()
  }
}

function smartCartUpdatePackingCartAttribute(newValue = "") {
  const formData = new FormData();
  formData.append("attributes[_packing_type]", newValue);

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  // DEBUG
  // .then(response => response.json())
  // .then(data => console.log(data));
}

function handleSmartCartPackingSelection(packContainer) {
  const selectedPack = packContainer.querySelector('input:checked')
  if (selectedPack) smartCartUpdatePackingCartAttribute(selectedPack.value)
}

function handleChangesInSmartCart(rebuyPack) {
  if(!rebuyPack || rebuyWaitForProductDataCounter > 10) return

  const { SmartCart } = Rebuy;
  const items = SmartCart.items()
  const cartTags = []
  const newProductsInCart = []

  if(items.length && !items[0].product) {
    rebuyWaitForProductDataCounter ++
    setTimeout(() => {
      handleChangesInSmartCart(rebuyPack)
    }, 50);
    return
  }
  rebuyWaitForProductDataCounter = 0

  if (items.length) {
    items.forEach((item) => {
      if (item.product && item.product.tags) {
        const itemTags = item.product.tags.split(', ');
        cartTags.push(...itemTags);
      }
      newProductsInCart.push(item.id)
    })
  }

  if (newProductsInCart.toString() === rebuySmartCartItems.toString()) return
  rebuySmartCartItems = [...newProductsInCart]

  if(!items.length || cartTags.includes('GABARYT')) {
    rebuyPack.classList.remove('enabled')
    smartCartUpdatePackingCartAttribute()
  } else {
    rebuyPack.classList.add('enabled')
    handleSmartCartPackingSelection(rebuyPack)
  }
};